import React from 'react';
import { Offer } from '../types';
import { Check, Clock, DollarSign, Info } from 'lucide-react';
interface CashbackDetailsCardProps {
  offer: Offer;
}
export function CashbackDetailsCard({
  offer
}: CashbackDetailsCardProps) {
  return <div className="bg-green-50 border-l-4 border-green-600 rounded-xl p-6 md:p-8 shadow-sm" data-id="element-63">
      <div className="flex items-center gap-3 mb-6" data-id="element-64">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-65">
          <DollarSign className="w-6 h-6 text-green-700" data-id="element-66" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-67">
          Cashback Offer Details
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-68">
        <div className="space-y-4" data-id="element-69">
          <div className="flex items-start gap-3" data-id="element-70">
            <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-71" />
            <div data-id="element-72">
              <p className="font-bold text-gray-900 text-lg" data-id="element-73">
                Earn {offer.cashbackPercent}% Back
              </p>
              <p className="text-gray-600" data-id="element-74">On every eligible purchase</p>
            </div>
          </div>

          <div className="flex items-start gap-3" data-id="element-75">
            <Info className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-76" />
            <div data-id="element-77">
              <p className="font-bold text-gray-900 text-lg" data-id="element-78">
                Max Cashback: ${offer.maxCashback}
              </p>
              <p className="text-gray-600" data-id="element-79">Per transaction limit</p>
            </div>
          </div>
        </div>

        <div className="space-y-4" data-id="element-80">
          <div className="flex items-start gap-3" data-id="element-81">
            <Clock className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-82" />
            <div data-id="element-83">
              <p className="font-bold text-gray-900 text-lg" data-id="element-84">Valid Until</p>
              <p className="text-gray-600" data-id="element-85">
                {new Date(offer.expiresAt).toLocaleDateString()}
              </p>
            </div>
          </div>

          <div className="space-y-2" data-id="element-86">
            <p className="font-bold text-gray-900 text-lg mb-2" data-id="element-87">
              Terms & Conditions:
            </p>
            <ul className="space-y-2" data-id="element-88">
              {offer.terms.map((term, index) => <li key={index} className="flex items-center gap-2 text-gray-700" data-id="element-89">
                  <span className="w-1.5 h-1.5 bg-green-600 rounded-full" data-id="element-90"></span>
                  {term}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}